import { useMappingStore } from '@/stores/mappingStore.ts'

type EventService = {
  setDisabled(mappingKey: string, isDisabled: boolean): void
  setFieldValue(mappingKey: string, value: any): void
}

const createEventService = (): EventService => {
  const setDisabled = (mappingKey: string, isDisabled: boolean) => {
    useMappingStore()
      .getFieldsOfKey('calculator', mappingKey)
      .value.forEach((field) => (field.config.disabled = isDisabled))
  }

  const setFieldValue = (mappingKey: string, value: any) => {
    useMappingStore()
      .getFieldsOfKey('calculator', mappingKey)
      .value.forEach((field) => (field.config.value = value))
  }

  return { setDisabled, setFieldValue }
}

let _EventService: EventService | null = null

export const EventService = (): EventService => {
  if (!_EventService) {
    _EventService = createEventService()
  }
  return _EventService
}
